import { CUSTOM_LOGIN, WIX_FORMS } from '@wix/app-definition-ids';
// Component types should also be added to the ComponentType enum in a11y-adapter
export const INACCESSIBLE_COMPONENTS = {
  Accordion: {
    componentType: 'tpa.viewer.components.Accordion'
  },
  AdminLoginButton: {
    componentType: 'wysiwyg.viewer.components.AdminLoginButton'
  },
  AppWidget: {
    componentType: 'platform.components.AppWidget',
    widgetIds: ['c7fddce1-ebf5-46b0-a309-7865384ba63f']
  },
  AudioPlayer: {
    componentType: 'wysiwyg.viewer.components.AudioPlayer'
  },
  BgImageStrip: {
    componentType: 'wysiwyg.viewer.components.BgImageStrip'
  },
  Captcha: {
    componentType: 'wixui.Captcha'
  },
  Collage: {
    componentType: 'tpa.viewer.components.Collage'
  },
  FlickrBadgeWidget: {
    componentType: 'wysiwyg.viewer.components.FlickrBadgeWidget'
  },
  Freestyle: {
    componentType: 'tpa.viewer.components.Freestyle'
  },
  Honeycomb: {
    componentType: 'tpa.viewer.components.Honeycomb'
  },
  HorizontalMenu: {
    componentType: 'wixui.StylableHorizontalMenu'
  },
  Impress: {
    componentType: 'tpa.viewer.components.Impress'
  },
  ItunesButton: {
    componentType: 'wysiwyg.viewer.components.ItunesButton'
  },
  LineShareButton: {
    componentType: 'wixui.LineShareButton'
  },
  LoginButton: {
    componentType: 'wysiwyg.viewer.components.LoginButton'
  },
  Masonry: {
    componentType: 'tpa.viewer.components.Masonry'
  },
  MatrixGallery: {
    componentType: 'wysiwyg.viewer.components.MatrixGallery'
  },
  Menu: {
    componentType: 'wixui.Menu'
  },
  OldForm: {
    componentType: 'wysiwyg.viewer.components.FormContainer'
  },
  PaginatedGridGallery: {
    componentType: 'wysiwyg.viewer.components.PaginatedGridGallery'
  },
  PinItPinWidget: {
    componentType: 'wysiwyg.common.components.pinitpinwidget.viewer.PinItPinWidget'
  },
  PinterestFollow: {
    componentType: 'wysiwyg.viewer.components.PinterestFollow'
  },
  PinterestPinIt: {
    componentType: 'wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt'
  },
  RSSButton: {
    componentType: 'wysiwyg.common.components.rssbutton.viewer.RSSButton'
  },
  RefComponent: {
    componentType: 'wysiwyg.viewer.components.RefComponent',
    widgetIds: ['89c4023a-027e-4d2a-b6b7-0b9d345b508d', '3dc66bc5-5354-4ce6-a436-bd8394c09b0e', '25ab36f9-f8bd-4799-a887-f10b6822fc2e']
  },
  SearchBox: {
    componentType: 'wixui.SearchBox'
  },
  SignatureInput: {
    componentType: 'wixui.SignatureInput'
  },
  SingleAudioPlayer: {
    componentType: 'wysiwyg.common.components.singleaudioplayer.viewer.SingleAudioPlayer'
  },
  SkypeCallButton: {
    componentType: 'wysiwyg.common.components.skypecallbutton.viewer.SkypeCallButton'
  },
  SlideShowGallery: {
    componentType: 'wysiwyg.viewer.components.SlideShowGallery'
  },
  SliderGallery: {
    componentType: 'wysiwyg.viewer.components.SliderGallery'
  },
  SoundCloudWidget: {
    componentType: 'wysiwyg.viewer.components.SoundCloudWidget'
  },
  SpotifyFollow: {
    componentType: 'wysiwyg.common.components.spotifyfollow.viewer.SpotifyFollow'
  },
  SpotifyPlayer: {
    componentType: 'wysiwyg.common.components.spotifyplayer.viewer.SpotifyPlayer'
  },
  StripShowcase: {
    componentType: 'tpa.viewer.components.StripShowcase'
  },
  StripSlideshow: {
    componentType: 'tpa.viewer.components.StripSlideshow'
  },
  TPA3DCarousel: {
    componentType: 'wysiwyg.viewer.components.tpapps.TPA3DCarousel'
  },
  TPA3DGallery: {
    componentType: 'wysiwyg.viewer.components.tpapps.TPA3DGallery'
  },
  Thumbnails: {
    componentType: 'tpa.viewer.components.Thumbnails'
  },
  TpaMultiSection: {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    widgetIds: ['14f260e4-ea13-f861-b0ba-4577df99b961', '14f26118-b65b-b1c1-b6db-34d5da9dd623', '14f260f9-c2eb-50e8-9b3c-4d21861fe58f', '14f26109-514f-f9a8-9b3c-4d21861fe58f', 'e5a2773b-0e6b-4cbb-a012-3b4a69e92046']
  },
  TpaWidget: {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
    widgetIds: ['14756c3d-f10a-45fc-4df1-808f22aabe80', '53d0a5fa-3da5-418b-84d6-e58bd55fecad', '14a85b28-2374-72cf-db64-e0c11046aa60', '1405f006-9eda-ce95-96c3-403f44d9e58a']
  },
  TwitterFeed: {
    componentType: 'wysiwyg.viewer.components.TwitterFeed'
  },
  VKShareButton: {
    componentType: 'wysiwyg.viewer.components.VKShareButton'
  },
  Video: {
    componentType: 'wysiwyg.viewer.components.Video'
  },
  VideoPlayer: {
    componentType: 'wixui.VideoPlayer'
  },
  WFacebookComment: {
    componentType: 'wysiwyg.viewer.components.WFacebookComment'
  },
  WTwitterFollow: {
    componentType: 'wysiwyg.viewer.components.WTwitterFollow'
  },
  WTwitterTweet: {
    componentType: 'wysiwyg.viewer.components.WTwitterTweet'
  },
  YouTubeSubscribeButton: {
    componentType: 'wysiwyg.common.components.youtubesubscribebutton.viewer.YouTubeSubscribeButton'
  }
};
export const INACCESSIBLE_TPA_COMPONENTS = {
  '1405f006-9eda-ce95-96c3-403f44d9e58a': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
    name: 'BandsInTown'
  },
  '14756c3d-f10a-45fc-4df1-808f22aabe80': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
    name: 'FeaturedService'
  },
  '14a85b28-2374-72cf-db64-e0c11046aa60': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
    name: 'SoundCloud'
  },
  '14f260e4-ea13-f861-b0ba-4577df99b961': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    name: 'MyDrafts'
  },
  '14f260f9-c2eb-50e8-9b3c-4d21861fe58f': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    name: 'BlogComments'
  },
  '14f26109-514f-f9a8-9b3c-4d21861fe58f': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    name: 'BlogLikes'
  },
  '14f26118-b65b-b1c1-b6db-34d5da9dd623': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    name: 'BlogPosts'
  },
  '25ab36f9-f8bd-4799-a887-f10b6822fc2e': {
    componentType: 'wysiwyg.viewer.components.RefComponent',
    name: 'PostPageOnBlocks'
  },
  '3dc66bc5-5354-4ce6-a436-bd8394c09b0e': {
    componentType: 'wysiwyg.viewer.components.RefComponent',
    name: 'StaffWidget'
  },
  '53d0a5fa-3da5-418b-84d6-e58bd55fecad': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
    name: 'SpotifyPlayer'
  },
  '89c4023a-027e-4d2a-b6b7-0b9d345b508d': {
    componentType: 'wysiwyg.viewer.components.RefComponent',
    name: 'DailyTimeTable'
  },
  'c7fddce1-ebf5-46b0-a309-7865384ba63f': {
    componentType: 'platform.components.AppWidget',
    name: 'BookButton'
  },
  'e5a2773b-0e6b-4cbb-a012-3b4a69e92046': {
    componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    name: 'MyPosts'
  }
};
export const ALTERNATIVE_COMPONENTS = {
  BlogApp: {
    key: 'blog-app'
  },
  Button: {
    key: 'button'
  },
  Captcha: {
    key: 'captcha'
  },
  DailyAgenda: {
    key: 'daily-agenda'
  },
  EditorNaiveButton: {
    key: 'editor-naive-button'
  },
  FeaturedService: {
    key: 'featured-service'
  },
  HTMLEmbed: {
    key: 'embed-code'
  },
  NewForms: {
    key: 'new-forms'
  },
  ProGallery: {
    key: 'pro-gallery'
  },
  ShareButtons: {
    key: 'share-button'
  },
  SignatureInput: {
    key: 'signature-input'
  },
  SiteSearch: {
    key: 'site-search'
  },
  StretchedImage: {
    key: 'stretched-image'
  },
  WixMusicPlayer: {
    key: 'wix-music-player'
  },
  WixVideo: {
    key: 'wix-video'
  }
};
export const INACCESSIBLE_COMPONENTS_ALTERNATIVES = {
  Accordion: 'ProGallery',
  AdminLoginButton: 'Button',
  AudioPlayer: 'WixMusicPlayer',
  BgImageStrip: 'StretchedImage',
  Captcha: 'Captcha',
  Collage: 'ProGallery',
  FlickrBadgeWidget: 'HTMLEmbed',
  Freestyle: 'ProGallery',
  Honeycomb: 'ProGallery',
  HorizontalMenu: null,
  Impress: 'ProGallery',
  ItunesButton: null,
  LineShareButton: 'ShareButtons',
  LoginButton: 'Button',
  Masonry: 'ProGallery',
  MatrixGallery: 'ProGallery',
  Menu: null,
  OldForm: 'NewForms',
  PaginatedGridGallery: 'ProGallery',
  PinItPinWidget: 'HTMLEmbed',
  PinterestFollow: 'HTMLEmbed',
  PinterestPinIt: 'HTMLEmbed',
  RSSButton: 'HTMLEmbed',
  SearchBox: 'SiteSearch',
  SignatureInput: 'SignatureInput',
  SingleAudioPlayer: 'WixMusicPlayer',
  SkypeCallButton: 'HTMLEmbed',
  SlideShowGallery: 'ProGallery',
  SliderGallery: 'ProGallery',
  SoundCloudWidget: 'HTMLEmbed',
  SpotifyFollow: 'HTMLEmbed',
  SpotifyPlayer: 'HTMLEmbed',
  StripShowcase: 'ProGallery',
  StripSlideshow: 'ProGallery',
  TPA3DCarousel: 'ProGallery',
  TPA3DGallery: 'ProGallery',
  Thumbnails: 'ProGallery',
  TwitterFeed: 'HTMLEmbed',
  VKShareButton: 'ShareButtons',
  Video: 'WixVideo',
  VideoPlayer: 'WixVideo',
  WFacebookComment: 'HTMLEmbed',
  WTwitterFollow: 'HTMLEmbed',
  WTwitterTweet: 'HTMLEmbed',
  YouTubeSubscribeButton: 'HTMLEmbed'
};
export const TPA_ALTERNATIVES = {
  BandsInTown: null,
  BlogComments: null,
  BlogLikes: null,
  BlogPosts: null,
  BookButton: 'EditorNaiveButton',
  DailyTimeTable: 'DailyAgenda',
  FeaturedService: 'FeaturedService',
  MyDrafts: null,
  MyPosts: null,
  PostPageOnBlocks: 'BlogApp',
  SoundCloud: null,
  SpotifyPlayer: null,
  StaffWidget: null
};
export const REINSTALL_COMPONENTS_TYPES = [INACCESSIBLE_COMPONENTS.SignatureInput.componentType, INACCESSIBLE_COMPONENTS.Captcha.componentType];
export const FOLLOW_ARTICLE_COMPONENTS_TYPES = [INACCESSIBLE_COMPONENTS.RefComponent.componentType, INACCESSIBLE_COMPONENTS.SearchBox.componentType, INACCESSIBLE_COMPONENTS.TpaWidget.componentType, INACCESSIBLE_COMPONENTS.TpaMultiSection.componentType, INACCESSIBLE_COMPONENTS.HorizontalMenu.componentType, INACCESSIBLE_COMPONENTS.Menu.componentType];
export const FOLLOW_ARTICLE_TPA_IDS = {
  PostPageOnBlocks: '25ab36f9-f8bd-4799-a887-f10b6822fc2e'
};
export const INACCESSIBLE_COMPONENTS_TYPES = Object.values(INACCESSIBLE_COMPONENTS).map(_ref => {
  let {
    componentType
  } = _ref;
  return componentType;
});
export let MembersWidgetAppId = /*#__PURE__*/function (MembersWidgetAppId) {
  MembersWidgetAppId[MembersWidgetAppId["SignUp"] = WIX_FORMS] = "SignUp";
  MembersWidgetAppId[MembersWidgetAppId["SignIn"] = CUSTOM_LOGIN] = "SignIn";
  return MembersWidgetAppId;
}({});
//# sourceMappingURL=constants.js.map